import { render, staticRenderFns } from "./personal-information-resource-item-1-account-information-settings.vue?vue&type=template&id=1ecef791&"
import script from "./personal-information-resource-item-1-account-information-settings.vue?vue&type=script&lang=ts&"
export * from "./personal-information-resource-item-1-account-information-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports